import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

// Tabler icons (https://tabler.io/icons) wrapped as MUI SvgIcon components so
// they pick up MUI sizing/color tokens (fontSize, color, sx). Add new tabler
// icons here by copying their SVG paths and following the same pattern.

const tablerSx = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
}

const withTablerDefaults = (props: SvgIconProps): SvgIconProps => ({
  ...props,
  viewBox: '0 0 24 24',
  sx: { ...tablerSx, ...props.sx },
})

export const LayoutSidebarLeftCollapseIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...withTablerDefaults(props)}>
    <path d="M4 6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2l0 -12" />
    <path d="M9 4v16" />
    <path d="M15 10l-2 2l2 2" />
  </SvgIcon>
)

export const LayoutSidebarLeftExpandIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...withTablerDefaults(props)}>
    <path d="M4 6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2l0 -12" />
    <path d="M9 4v16" />
    <path d="M14 10l2 2l-2 2" />
  </SvgIcon>
)

export const LayoutSidebarRightCollapseIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...withTablerDefaults(props)}>
    <path d="M4 6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2l0 -12" />
    <path d="M15 4v16" />
    <path d="M9 10l2 2l-2 2" />
  </SvgIcon>
)

export const LayoutSidebarRightExpandIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...withTablerDefaults(props)}>
    <path d="M4 6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2l0 -12" />
    <path d="M15 4v16" />
    <path d="M10 10l-2 2l2 2" />
  </SvgIcon>
)
